import React from 'react'
import rotas from '../../helper/resources/paths'
import { withStyles } from "@material-ui/core/styles";
import MenuDebitsItem from '../MenuDebitsItem'

const styles = () => ({
    menuGroup: {
        display: 'flex',
        width: '100%',
        marginTop: '10px',
        marginBottom: '30px',
        padding: '20px 0px 0px 0px',
    },
})

function MenuDebitsManager(props) {
    return (
        <div className={props.classes.menuGroup}>
            <MenuDebitsItem
                path={rotas.HOME}
                label="DÉBITOS"
            />
            <MenuDebitsItem
                path={rotas.DEBITOS_OCULTADOS}
                label="DÉBITOS OCULTADOS"
            />
            <MenuDebitsItem
                path={rotas.BANCOS}
                label="BANCOS"
            />
            <MenuDebitsItem
                path={rotas.DAM}
                label="DAM"
            />
            <MenuDebitsItem
                path={rotas.ADQUIRENTES}
                label="ADQUIRENTES"
            />
        </div>
    )
}

export default withStyles(styles, { withTheme: true })(MenuDebitsManager)
